import angular from "angular";
import AppLanguageSelectorComponent from "./app-language-selector/app-language-selector";
import BrandingSettingsComponent from "./branding-settings/branding-settings";
import CurrencySelectorComponent from "./currency-selector/currency-selector";
import QuoteLanguageSelectorComponent from "./quote-language-selector/quote-language-selector";
import CustomDomainSettingsComponent from "./custom-domain-settings/custom-domain-settings";
import OrganizationProfileComponent from "./organization-profile/organization-profile";
import OrganizationSettingsPageComponent from "./organization-settings-page/organization-settings-page";
import SettingsComponent from "./settings/settings";
import SettingsExpirationPeriodComponent from "./settings-expiration-period/settings-expiration-period";
import SettingsQuoteNumbersRowComponent from "./settings-quote-numbers-row/settings-quote-numbers-row";
import SettingsSignatureComponent from "./settings-signature/settings-signature";
import SettingsTeamComponent from "./settings-team/settings-team";
import SettingsTaxesComponent from "./settings-taxes/settings-taxes";
import SettingsTaxesRowComponent from "./settings-taxes-row/settings-taxes-row";
import TimezoneSelectorComponent from "./timezone-selector/timezone-selector";

const OrganizationSettingsModule = angular
  .module("modules.organizationSettings", [])
  .component("appLanguageSelector", AppLanguageSelectorComponent)
  .component("brandingSettings", BrandingSettingsComponent)
  .component("currencySelector", CurrencySelectorComponent)
  .component("quoteLanguageSelector", QuoteLanguageSelectorComponent)
  .component("customDomainSettings", CustomDomainSettingsComponent)
  .component("organizationProfile", OrganizationProfileComponent)
  .component("organizationSettingsPage", OrganizationSettingsPageComponent)
  .component("settings", SettingsComponent)
  .component("settingsExpirationPeriod", SettingsExpirationPeriodComponent)
  .component("settingsTaxes", SettingsTaxesComponent)
  .component("settingsTaxesRow", SettingsTaxesRowComponent)
  .component("settingsQuoteNumbersRow", SettingsQuoteNumbersRowComponent)
  .component("settingsSignature", SettingsSignatureComponent)
  .component("settingsTeam", SettingsTeamComponent)
  .component("timezoneSelector", TimezoneSelectorComponent);

export default OrganizationSettingsModule;
